import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import MainButton from '../../../shared/layout/buttons/MainButton';
import AdminFilterBar from './components/AdminFilterBar';
import AdminDataTable from './components/AdminDataTable';
import { fetchAdminFailedTransactions } from '../../../services/Http/AdminApi';

const AdminFailedTransactions = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const resp = await fetchAdminFailedTransactions({ period: '30d', per_page: 25 });
            setRows(resp?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to load failed transactions');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const columns = useMemo(() => ([
        { key: 'id', label: 'ID' },
        { key: 'created_at', label: 'Created', render: (row) => row.created_at ? new Date(row.created_at).toLocaleString() : '—' },
        { key: 'transaction_type', label: 'Type' },
        { key: 'serial_number', label: 'Serial' },
        { key: 'error_message', label: 'Error' },
    ]), []);

    return (
        <PageContainer>
            <PageHeader><PageTitle>Failed Transactions</PageTitle></PageHeader>
            <PageContent>
                <AdminFilterBar>
                    <div>Failed transaction attempts in selected period</div>
                    <MainButton size="small" onClick={load}>Refresh</MainButton>
                </AdminFilterBar>
                <AdminDataTable columns={columns} rows={rows} loading={loading} emptyText="No failed transactions" />
            </PageContent>
        </PageContainer>
    );
};

export default AdminFailedTransactions;

